import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { NgxGuiCommonModule } from '@complibrary/ngx-gui-common';

import { ButtonModule } from 'primeng/button';
import { AppRoutingModule } from './app-routing.module';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { PagesModule } from './pages/pages.module';
import { SharedModule } from './shared/shared.module';


import { ApiModule } from './api/api.module';
import { AuthInterceptor } from './api/interceptors/auth.interceptor';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import Lara from '@primeng/themes/lara';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from "@primeng/themes";
import {sv} from 'primelocale/sv.json'


const pngOverride = definePreset(Lara,
  {
    semantic: {
      colorScheme: {
        light: {
          primary: {
            color: '#495057'
          },
          highlight: {
            background: '#EAEEF4',
            color: '#000'
          }
        }
      }
    }
  });

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthModule,
    SharedModule,
    PagesModule,
    ApiModule,
    ButtonModule,
  ],
  providers: [
    {
      provide: 'APP_CONFIG',
      useValue: {
        apiUrl: environment.apiUrl,
        authUrl: environment.authUrl,
        webUrl: environment.webUrl,
      }
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: 'Clipboard', useValue: window.navigator.clipboard },
    DialogService,
    MessageService,
    provideZoneChangeDetection({ eventCoalescing: true }),

    provideAnimationsAsync(),
    providePrimeNG({
      translation: sv,
      theme: {
        preset: pngOverride,
        options: {
          darkModeSelector: false || 'none'
        }

      },
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
